jQuery(document).ready(function() {
   const searchTrigger = document.getElementById('js-primary-menu-search-trigger');
   const searchElement = document.getElementById('js-primary-menu-search');
   const menuItems = document.querySelectorAll('#nav-primary .menu-item:not(.menu-item-search)');
   const searchInput = document.querySelector('#nav-primary input#searchwp');  // Added search input selector

   // Add initial styles
   searchElement.style.transition = 'opacity 0.2s ease-in-out';
   searchElement.style.opacity = '0';
   searchElement.style.display = 'none';

   let isSearchOpen = false;

   searchTrigger.addEventListener('click', () => {
       if (!isSearchOpen) {
           // Opening sequence
           // 1. Fade out menu items
           menuItems.forEach(item => {
               item.style.transition = 'opacity 0.2s ease-in-out';
               item.style.opacity = '0';
           });

           // 2. After fade completes, fade in search
           setTimeout(() => {
               menuItems.forEach(item => item.style.display = 'none');
               searchElement.style.display = 'block';
               // Trigger reflow to ensure transition works
               searchElement.offsetHeight;
               searchElement.style.opacity = '1';

               // 3. Change icon to X and focus search input after fade in completes
               setTimeout(() => {
                   searchTrigger.classList.remove('fa', 'fa-search');
                   searchTrigger.classList.add('fa-regular', 'fa-times', 'search-open');
                   searchInput.focus();  // Set focus to search input
               }, 200);
           }, 200);

       } else {
           // Closing sequence
           // 1. Change icon back to search immediately
           searchTrigger.classList.remove('fa-regular', 'fa-times', 'search-open');
           searchTrigger.classList.add('fa', 'fa-search');

           // 2. Fade out search
           searchElement.style.opacity = '0';

           // 3. After fade completes, fade in menu items
           setTimeout(() => {
               searchElement.style.display = 'none';
               menuItems.forEach(item => {
                   item.style.display = '';
                   item.style.opacity = '0';
                   // Trigger reflow
                   item.offsetHeight;
                   item.style.opacity = '1';
               });
           }, 200);
       }

       isSearchOpen = !isSearchOpen;
   });
});
